import React, { Component } from 'react';
import { Input, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';

class ArchkYesNo extends Component {

    state = {

    };

    onChange = (e) => {

        let value = e.target.value

        this.setState({value})

        if(this.props.onChange) {
            this.props.onChange(`${value}`)
        }

    }

    render() {

        const { label } = this.props

        return (

            <FormGroup>

                {label ? ( <label className="form-control-label mb-0">{label}</label> ) : null}

                <div className="archk-select">
                    <Input
                        // value={this.state.value || ''}
                        onChange={this.onChange}
                        type="select"
                    >

                        <option></option>

                        <option value="yes">Yes</option>
                        <option value="no">No</option>

                    </Input>

                </div>

            </FormGroup>

        )

    }

}

ArchkYesNo.propTypes = {

    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,

}

export default ArchkYesNo;
